import { Component, EventEmitter, forwardRef, Input, Output } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AdMessageService } from "@internal/common-ui/ad-message";

export const ADUPLOAD_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => AdUploadComponent),
  multi: true
}
export interface IFileUpload {
  file: File;
  disabled?: boolean;
  fileName: string;
}

@Component({
  selector: 'ad-upload',
  templateUrl: './ad-upload.component.html',
  styleUrls: ['./ad-upload.component.scss'],
  providers: [ADUPLOAD_VALUE_ACCESSOR]
})
export class AdUploadComponent implements ControlValueAccessor {
  @Input()
  files: IFileUpload[] = [];

  @Input()
  disabled: boolean = false;

  @Input()
  accept: string = '';

  @Output()
  onChange: EventEmitter<IFileUpload[]> = new EventEmitter();


  get isFilesUploaded() {
    return this.files?.length > 0;
  }

  constructor(
    private adMessageService: AdMessageService
  ) {

  }

  onFileChanged: (files: IFileUpload[]) => void = () => { };
  onTouched: () => void = () => { };
  writeValue(obj: IFileUpload[]): void {
    this.files = obj;
  }
  registerOnChange(fn: any): void {
    this.onFileChanged = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  isFileDeletable(file: IFileUpload) {
    return !this.disabled && !file.disabled;
  }
  onFileSelected(files: FileList) {
    let [acceptFiles, rejectedFiles] = [[], []];
    for (let i = 0; i < files.length; i++) {
      const { name } = files[i];
      if (this.isFileLegal(name)) {
        acceptFiles.push({ file: files[i], fileName: name });
      } else {
        rejectedFiles.push(name);
      }
    }
    if (rejectedFiles.length > 0) {
      this.adMessageService.confirm({
        message: `these files are not supported. ${rejectedFiles.join(', ')}`,
        dialogTitle: 'Warning',
      });
    }
    this.files.push(...acceptFiles);
    this.onChange.emit(this.files);
    this.onFileChanged(this.files);
  }

  removeFile(file: IFileUpload) {
    this.files = this.files.filter(it => it !== file);
    this.onChange.emit(this.files);
    this.onFileChanged(this.files);
  }

  isFileLegal(name: string) {
    if (this.accept?.length > 0) {
      const formats = this.accept.split(',').map(it => it.trim());
      return formats.filter(format => name.endsWith(format)).length > 0;
    }
    return true;
  }



}
